import styled from '@emotion/styled';
import { flexbox } from 'styled-system';
import { Box } from '../box/Box';
import { gap } from '../../custom-props/styled-system-gap';
/**
 * A layout component that lets you apply a range
 * of flex properties.
 */
export const Flex = styled(Box) `
  ${flexbox}
  ${gap}
`;
Flex.defaultProps = {
    display: 'flex',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmxleC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2ZsZXgvRmxleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0saUJBQWlCLENBQUM7QUFDckMsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUV4QyxPQUFPLEVBQUUsR0FBRyxFQUFZLE1BQU0sWUFBWSxDQUFDO0FBQzNDLE9BQU8sRUFBRSxHQUFHLEVBQWlCLE1BQU0sc0NBQXNDLENBQUM7QUFJMUU7OztHQUdHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sSUFBSSxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBVztJQUN0QyxPQUFPO0lBQ1AsR0FBRztDQUNOLENBQUM7QUFFRixJQUFJLENBQUMsWUFBWSxHQUFHO0lBQ2xCLE9BQU8sRUFBRSxNQUFNO0NBQ2hCLENBQUMifQ==